var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-48 flex flex-wrap content-center items-center"},[_c('h1',{staticClass:"m-auto"},[_vm._v("Loading...")]),_vm._v(" "),_c('div',{staticClass:"stage"},[_c('div',{staticClass:"box bounce-7"},[_c('img',{attrs:{"src":"/ms-icon-310x310.png","alt":""}})])])])
}]

export { render, staticRenderFns }